export default "__VITE_ASSET__BCM4mNTx__"